import React, { useEffect, useState } from 'react'

import CreateOrganisationModal from 'components/Modals/CreateOrganisationModal/CreateOrganisationModal'
import EditOrganisationModal from 'components/Modals/EditOrganisationModal/EditOrganisationModal'
import FetchOrgDetails from './FetchOrgDetails'
import SubmitOrgDetails from './SubmitOrgDetails'

export enum JOURNEYSTAGE {
  CREATE,
  FETCHING_ORG_DETAILS,
  EDIT_ORG_DETAILS,
  ORG_DETAILS_SUBMITTED,
  CLOSED,
}

interface Props {
  modal: boolean
  setModal: React.Dispatch<React.SetStateAction<boolean>>
  id?: string
  companyInfo?: {
    organisationName: string
    organisationWebsite: string
  }
}

export type CompanyInfo = {
  organisationName: string
  organisationWebsite: string
}

const CreateOrganisationJourney = ({
  modal,
  setModal,
  id = '',
  companyInfo = { organisationName: '', organisationWebsite: '' },
}: Props): JSX.Element | null => {
  const [journeyStage, setJourneyStage] = useState<JOURNEYSTAGE>(
    JOURNEYSTAGE.CREATE
  )

  const [company, setCompany] = useState<CompanyInfo>({
    organisationName: '',
    organisationWebsite: '',
  })

  const [companyId, setCompanyId] = useState<string>('')
  const [companyDetail, setCompanyDetail] = useState<Prefillbiodata>(
    {} as Prefillbiodata
  )

  useEffect(() => {
    if (!id) return
    setCompanyId(id)
  }, [id])

  const moveToHome = () => {
    window.location.href = `/${companyId}`
  }

  useEffect(() => {
    if (journeyStage === JOURNEYSTAGE.CLOSED) {
      setModal(false)
      setCompany({ organisationName: '', organisationWebsite: '' })
      setCompanyId('')
      setCompanyDetail({} as Prefillbiodata)
      setJourneyStage(JOURNEYSTAGE.CREATE)
    }
  }, [journeyStage, setModal, setJourneyStage, setCompanyId, setCompanyDetail])

  if (journeyStage === JOURNEYSTAGE.CREATE) {
    return (
      <CreateOrganisationModal
        modal={modal}
        setModal={setModal}
        company={company.organisationName ? company : companyInfo}
        companyId={companyId}
        setCompany={setCompany}
        setJourneyState={setJourneyStage}
        setCompanyID={setCompanyId}
      />
    )
  }

  if (journeyStage === JOURNEYSTAGE.FETCHING_ORG_DETAILS) {
    return (
      <FetchOrgDetails
        company={company}
        setJourneyState={setJourneyStage}
        companyId={companyId}
        setCompanyDetail={setCompanyDetail}
      />
    )
  }

  if (journeyStage === JOURNEYSTAGE.EDIT_ORG_DETAILS) {
    return (
      <EditOrganisationModal
        setJourneyState={setJourneyStage}
        companyId={companyId}
        data={companyDetail}
        company={company}
      />
    )
  }

  if (journeyStage === JOURNEYSTAGE.ORG_DETAILS_SUBMITTED) {
    return (
      <SubmitOrgDetails
        companyId={companyId}
        moveToHome={moveToHome}
        setJourneyState={setJourneyStage}
      />
    )
  }

  return null
}

export default CreateOrganisationJourney
